module.exports = __webpack_public_path__ + "img/ic_company-logo_04.5a3834ce.svg";